import { useState } from "react";
import { MapPinned, Route, History, ShieldAlert } from "lucide-react";
import { RoundPointsAdmin } from "../components/pti/RoundPointsAdmin";
import { RoundCircuitsAdmin } from "../components/pti/RoundCircuitsAdmin";
import { RoundRunsList } from "../components/pti/RoundRunsList";
import { PtiSettingsCard } from "../components/pti/PtiSettingsCard";
import { PtiAlarmsList } from "../components/pti/PtiAlarmsList";
import { useAuth } from "../context/AuthContext";

const TABS = [["points", "Points de ronde", MapPinned], ["circuits", "Rondes", Route], ["runs", "Passages", History], ["pti", "PTI & télésurveillance", ShieldAlert]];

export default function PtiRondes() {
  const [tab, setTab] = useState("points");
  const { user } = useAuth();
  if (user?.modules_off?.includes("pti_rondes")) return <div className="p-16 text-center text-slate-600" data-testid="pti-module-off">L&apos;option PTI & rondes n&apos;est pas activée pour votre entreprise. Contactez le service client XALTIX.</div>;
  return (
    <div className="p-4 md:p-8 max-w-[1800px] mx-auto space-y-5" data-testid="pti-rondes-page">
      <div>
        <h1 className="font-display text-4xl font-extrabold tracking-tight">PTI & rondes</h1>
        <p className="text-sm text-slate-600">Points de ronde NFC / QR code, circuits, passages des agents et liaison des alarmes PTI avec votre télésurveillance.</p>
      </div>
      <div className="flex gap-1 border-b border-slate-200 flex-wrap" data-testid="pti-rondes-tabs">
        {TABS.map(([k, l, Icon]) => (
          <button key={k} data-testid={`pti-rondes-tab-${k}`} onClick={() => setTab(k)}
            className={`px-4 py-2 text-sm font-semibold -mb-px border-b-2 inline-flex items-center gap-1.5 transition-colors ${tab === k ? "border-amber-600 text-amber-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            <Icon className="h-3.5 w-3.5" />{l}
          </button>
        ))}
      </div>
      {tab === "points" && <RoundPointsAdmin />}
      {tab === "circuits" && <RoundCircuitsAdmin />}
      {tab === "runs" && <RoundRunsList />}
      {tab === "pti" && (user?.role === "admin"
        ? <div className="space-y-5"><PtiSettingsCard /><PtiAlarmsList /></div>
        : <div className="text-sm text-slate-500" data-testid="pti-admin-only">Réservé aux administrateurs.</div>)}
    </div>
  );
}
